import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const SignUpBG = () => {
  const navigate = useNavigate();
  const { companyInfo } = useAuth();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;

  return (
    <div
      className="form-grid_right"
      style={{
        backgroundImage: "url(images/login-bg.jpg)",
      }}
    >
      <div className="form-right-img-block create-acc">
        <div className="btn-grid">
          <a
            href="#"
            className="cta-primary"
            onClick={() => navigate("/login")}
          >
            Sign In
          </a>
        </div>
        <header>
          <h2>
            <span>Unlock</span> the power of
          </h2>
          <h3>
            {!!parentAgency ? companyInfo?.orgName : "BottBuddy"} AI Chatbot
          </h3>
        </header>
        <figure>
          <img src="/images/create-account-img.png" alt />
        </figure>
      </div>
    </div>
  );
};
export default SignUpBG;
